import { Component, ViewChild } from "@angular/core";
import { VersionsComponent } from "src/app/pages/versions/versions.component";
import { environment } from "src/environments/environment";
import { AppComponent } from "../../app.component";

@Component({
    selector: "app-footer",
    templateUrl: "./app.footer.component.html",
    styleUrls: ["./app.footer.component.scss"],
})
export class AppFooterComponent {
    currentApplicationVersion = environment.appVersion;
    currentYear = new Date().getFullYear();
    @ViewChild("versionsComponent") versionsComponent: VersionsComponent;
    constructor(public app: AppComponent) {}

    openVersions() {
        this.versionsComponent.showDialog();
    }
}
